import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { InstallPWA } from "@/components/InstallPWA";
import { Zap, LogOut, LayoutDashboard, Shield } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 w-full border-b border-white/10 bg-black/60 backdrop-blur-2xl"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#00E676]">
            <Zap className="h-5 w-5 text-black" fill="black" />
          </span>
          <span className="font-display text-xl font-black tracking-tight">TipNu</span>
        </Link>

        <nav className="flex items-center gap-2">
          <InstallPWA />
          {user && user !== false ? (
            <>
              {user.role === "admin" && (
                <Button
                  variant="ghost"
                  data-testid="navbar-admin-btn"
                  onClick={() => navigate("/admin")}
                  className="rounded-full text-sm text-zinc-300 hover:bg-white/5 hover:text-white"
                >
                  <Shield className="mr-2 h-4 w-4" /> Admin
                </Button>
              )}
              <Button
                variant="ghost"
                data-testid="navbar-dashboard-btn"
                onClick={() => navigate("/dashboard")}
                className="rounded-full text-sm text-zinc-300 hover:bg-white/5 hover:text-white"
              >
                <LayoutDashboard className="mr-2 h-4 w-4" /> Dashboard
              </Button>
              <Button
                variant="ghost"
                data-testid="navbar-logout-btn"
                onClick={handleLogout}
                className="rounded-full text-sm text-zinc-300 hover:bg-white/5 hover:text-white"
              >
                <LogOut className="mr-2 h-4 w-4" /> Log out
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                data-testid="navbar-login-btn"
                onClick={() => navigate("/login")}
                className="rounded-full text-sm text-zinc-300 hover:bg-white/5 hover:text-white"
              >
                Log in
              </Button>
              <Button
                data-testid="navbar-register-btn"
                onClick={() => navigate("/register")}
                className="rounded-full bg-[#00E676] font-bold text-black hover:bg-[#00C853] active:scale-95"
              >
                Get paid
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
